import { createCookieConsentContext } from '@group-link-one/gl-utils';

export const COOKIE_PERMISSIONS = ['necessary', 'analytics'] as const;

export type CookiePermission = (typeof COOKIE_PERMISSIONS)[number];

export const { CookieConsentProvider, useCookieConsent } =
  createCookieConsentContext<CookiePermission>('utilities-cookies', COOKIE_PERMISSIONS);
